import { LessonTaskStepKey } from '../types/asset/lesson.types.ts';

export const LessonTaskStepKeys: Record<string, LessonTaskStepKey> = {
  DEFAULT_CURRENT: { lesson: 0, task: 0, step: 0 } as const,
  DEFAULT_LAST_COMPLETED: { lesson: -1, task: -1, step: -1 } as const,
} as const;
